import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { apiKey } from "../../../config/config";
import { languageHelper } from "../../../config/helperFunctions";

function AddBannerForm() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [bannerName, setBannerName] = useState();
  const [bannerImage, setBannerImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    let formData = new FormData();

    formData.append("banner_name", bannerName);
    formData.append("banner_image", bannerImage);
    formData.append("status", "active");
    formData.append("user_id", user?.user.id);
    formData.append("outlet_id", user?.user.outlet_id);

    // axios.get(apiKey + "/sanctum/csrf-cookie").then((response) => {
    //   // Extract the CSRF token from cookies
    //   const csrfToken = document.cookie
    //     .split("; ")
    //     .find((row) => row.startsWith("XSRF-TOKEN="))
    //     .split("=")[1];

    // After getting CSRF token, make the logout request

    axios
      .post(`${apiKey}/api/rms/admin/banners`, formData, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setLoading(false);
        navigate(-1);
      })
      .catch((err) => {
        Object.keys(err.response.data.data).forEach((item) => {
          err.response.data.data[item].forEach((i) => {
            toast.error(i || "Validation Error");
          });
        });
        setLoading(false);
      });
    // });
  };
  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-d-bg-text text-2xl">
              {languageHelper("Add Banner")}
            </h1>
          </div>
        </div>
        <div>
          <p className="text-d-bg-text ">
            {languageHelper("Add Image of size 1890 x578")}
          </p>
        </div>
        <div className="w-full">
          <form action="" className="w-full" onSubmit={handleSubmit}>
            <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 w-full">
              <label htmlFor="" className="w-full md:w-1/2">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Image")}
                </span>

                <div className="mb-2 pt-0">
                  <input
                    type="file"
                    onChange={(e) => setBannerImage(e.target.files[0])}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
              <label htmlFor="" className="w-full md:w-1/2">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Name")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Name"
                    onChange={(e) => setBannerName(e.target.value)}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            </div>
            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="https://i.gifer.com/ZKZx.gif"
                      alt=""
                    />
                  </span>
                )}
                {languageHelper("Submit")}
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                {languageHelper("Back")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default AddBannerForm;
